(() => {
  angular
    .module('gm.common.directives')
    .directive('gmTouchStart', gmTouchStartDirective);

  function gmTouchStartDirective() {
    'ngInject';

    const has = Object.prototype.hasOwnProperty;

    return {
      restrict: 'A',
      scope: {
        gmTouchStart: '&',
      },
      link(scope, element, attrs) {
        function onTouchStart($event) {
          const method = scope.gmTouchStart;
          scope.$apply(() => method({ $event }));
        }
        element.bind('touchstart', onTouchStart);
        const bindClick = has.call(attrs, 'gmTouchStartClick');
        if (bindClick) {
          element.bind('click', onTouchStart);
        }

        scope.$on('$destroy', () => {
          element.unbind('touchstart', onTouchStart);
          if (bindClick) {
            element.unbind('click', onTouchStart);
          }
        });
      }
    };
  }
})();
